export enum EntryScreenType {
  PauseTreatmentFromNextOrderManagement = "pause-treatment-next-order-management",
  PauseTreatmentFromCancellation = "pause-treatment-cancellation",
  TakeABreak = "take-a-break",
  EarlySet = "early-set",
}
